const CAP21 = {
  "id": 44,
  "title": "¿Dónde se guardan las transacciones entre usuarios?",
  "slug": "donde-se-guardan-las-transacciones-entre-usuarios",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "Introducción",
      "text": [
        "El concepto de 'blockchain' se introdujo inicialmente en 1991 por un grupo de investigadores, Stuart Haber y W. Scott Stornetta, quienes buscaban una forma de aplicar marcas de tiempo (timestamp) a documentos que no pudieran ser modificados.",
        "Años después, blockchain tomó mayor relevancia cuando Satoshi Nakamoto lo utilizó en 2009 como base tecnológica para crear la criptomoneda Bitcoin.",
        "Blockchain es un libro mayor distribuido que está completamente abierto a cualquier persona y, una vez que registra datos (transacciones) dentro de la cadena de bloques, es prácticamente imposible cambiarlos."
      ]
    },
    {
      "heading": "¿Dónde se guardan realmente las transacciones?",
      "text": [
        "Las transacciones entre usuarios se guardan en la blockchain, una base de datos pública, distribuida y compartida entre miles de computadoras alrededor del mundo.",
        "Cuando una persona realiza una transacción en Bitcoin, esa operación queda registrada dentro de un bloque. Una vez que ese bloque se confirma, pasa a formar parte de la cadena de bloques (blockchain) y permanece allí para siempre.",
        "Nadie puede borrar, modificar o falsificar esa información, porque se encuentra replicada en miles de nodos (computadoras) distribuidos globalmente."
      ]
    },
    {
      "heading": "La blockchain vista como una cartilla bancaria",
      "text": [
        "¿Sabes cómo funciona una cartilla de banco?",
        "En ella se anotan las operaciones de forma sucesiva en cada hoja, y cuando se llena, se pasa a la siguiente.",
        "La blockchain funciona de forma muy similar: cada bloque es como una hoja de la cartilla, y el conjunto de esas hojas es la cadena de bloques.",
        "Pero hay una gran diferencia: en los bancos, tu cartilla es privada, pero en Bitcoin, todos compartimos la misma cartilla, y esa cartilla es pública, transparente y abierta para cualquiera."
      ]
    },
    {
      "heading": "Lo realmente novedoso",
      "text": [
        "La novedad no está en que se registren las transacciones, sino en cómo y dónde se registran.",
        "La cartilla (blockchain) es la misma para todos los usuarios, está sincronizada globalmente y es pública.",
        "Cualquier persona puede ver el estado de las transacciones y verificar que las reglas del sistema se cumplen correctamente."
      ]
    },
    {
      "heading": "Características que hacen única a la blockchain",
      "list": [
        "No hay autoridad central para administrar la base de datos, lo que evita manipulaciones.",
        "Es una base de datos de solo agregar, no se puede modificar lo ya registrado.",
        "Sistema distribuido tipo “peer to peer” (P2P).",
        "Mayor eficiencia y transparencia.",
        "Utiliza criptografía para garantizar seguridad, confianza e integridad.",
        "Utiliza mecanismos de consenso como PoW (Prueba de Trabajo) para validar transacciones.",
        "Es de código abierto, lo que significa que está disponible para todo el mundo."
      ]
    },
    {
      "heading": "Resumen",
      "list": [
        "Las transacciones se guardan en la blockchain.",
        "La blockchain es pública, abierta, distribuida y segura.",
        "Cada bloque registra transacciones y se enlaza con el anterior.",
        "Una vez registrada, una transacción es prácticamente imposible de modificar.",
        "Todos compartimos la misma cartilla digital global."
      ]
    }
  ]
};

export default CAP21;

